import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import KInputSearch from '@kso/ui/lib/InputSearch';
import '@kso/ui/lib/InputSearch/style.css';
import KFinderMainEmpty from '@kso/ui/lib/FinderMainEmpty';
import '@kso/ui/lib/FinderMainEmpty/style.css';
import KFinderMainList from '@kso/ui/lib/FinderMainList';
import '@kso/ui/lib/FinderMainList/style.css';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { fetchFilesByUrl, fetchKdMyTeams, fetchDevicesPath, fetchJoinedCompanies, fetchFilePath, getKdMyTeamsDetail, getCompanyPrivate, fetchGroupFiles, searchFinderGroup, searchFinderFile, createFolder } from '@kso/ui/lib/request';
import { t } from '@kso/ui/lib/config/locale';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Emitter from 'element-ui/lib/mixins/emitter';
import ElBreadcrumb from 'element-ui/lib/breadcrumb';
import 'element-ui/lib/theme-chalk/breadcrumb.css';
import ElBreadcrumbItem from 'element-ui/lib/breadcrumb-item';
import 'element-ui/lib/theme-chalk/breadcrumb-item.css';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import throttle from 'lodash/throttle';

var ControlButton = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-finder-main-control-button"
    }, [_c('KIcon', {
      staticClass: "k-finder-main-control-button-back",
      "class": {
        'disabled': _vm.current < 1
      },
      attrs: {
        "type": "back"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.go(-1);
        }
      }
    }), _vm._v(" "), _c('KIcon', {
      staticClass: "k-finder-main-control-button-forward",
      "class": {
        'disabled': _vm.current + 1 === _vm.history.length
      },
      attrs: {
        "type": "back"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.go(1);
        }
      }
    })], 1);
  },
  staticRenderFns: [],
  components: {
    KIcon: KIcon
  },
  props: {
    current: Number,
    history: Array
  },
  methods: {
    go: function go(flag) {
      this.$emit('go', flag);
    }
  }
};

var _excluded = ["groupid", "file", "group", "corpid"];
var fileMixin = {
  data: function data() {
    return {
      params: {
        offset: 0,
        count: 20,
        max_mtime: null,
        filter: null
      }
    };
  },
  computed: {
    hasSecretFolder: function hasSecretFolder() {
      // 有没有私密文件夹权限
      return this.secretFolderID;
    },
    isSecretExpired: function isSecretExpired() {
      // 私密文件夹权限是否过期
      var isVip = [20, 40].includes(this.user.vip && this.user.vip.current_personal_vip && Number(this.user.vip.current_personal_vip.vip_id));
      return !!(this.hasSecretFolder && !isVip);
    }
  },
  methods: {
    resetParams: function resetParams() {
      this.params = {
        offset: 0,
        count: 20,
        max_mtime: null,
        filter: null
      };
    },
    fetch: function fetch() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var source, config, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              source = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              config = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
              list = [];
              if (!config.loadMore) {
                _context.next = 8;
                break;
              }
              if (!(_this.params.offset === -1)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", list);
            case 6:
              _context.next = 9;
              break;
            case 8:
              _this.resetParams();
            case 9:
              _context.t0 = source.routeName;
              _context.next = _context.t0 === 'Tags' ? 12 : _context.t0 === 'All' ? 16 : _context.t0 === 'Enterprise' ? 20 : _context.t0 === 'Team' ? 24 : _context.t0 === 'Received' ? 28 : _context.t0 === 'Latest' ? 32 : _context.t0 === 'Secret' ? 36 : _context.t0 === 'Sharing' ? 40 : _context.t0 === 'Devices' ? 44 : _context.t0 === 'Device' ? 48 : _context.t0 === 'MyTeams' ? 52 : 55;
              break;
            case 12:
              _context.next = 14;
              return _this.fetchTags(source, config);
            case 14:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 16:
              _context.next = 18;
              return _this.fetchAll(source, config);
            case 18:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 20:
              _context.next = 22;
              return _this.fetchEnterprise(source, config);
            case 22:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 24:
              _context.next = 26;
              return _this.fetchTeam(source, config);
            case 26:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 28:
              _context.next = 30;
              return _this.fetchLinks(source, config);
            case 30:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 32:
              _context.next = 34;
              return _this.fetchLatest(source, config);
            case 34:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 36:
              _context.next = 38;
              return _this.fetchTeam(source, config);
            case 38:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 40:
              _context.next = 42;
              return _this.fetchSharingReceived(source, config);
            case 42:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 44:
              _context.next = 46;
              return _this.fetchDevices(source, config);
            case 46:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 48:
              _context.next = 50;
              return _this.fetchDevice(source, config);
            case 50:
              list = _context.sent;
              return _context.abrupt("break", 55);
            case 52:
              _context.next = 54;
              return _this.fetchMyTeams(source, config);
            case 54:
              list = _context.sent;
            case 55:
              if (list.length === 0) {
                _this.params.offset = -1;
              }
              return _context.abrupt("return", list);
            case 57:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchLatest: function fetchLatest(source, config) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var baseUrl, params, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              baseUrl = '/api/v3/roaming';
              params = {
                offset: 0,
                count: 20,
                without_sid: true
              };
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this2.params);
              }
              _context2.next = 6;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 6:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 9;
                break;
              }
              _context2.t0 = [];
            case 9:
              data = _context2.t0;
              if (data && data.length) {
                _this2.params.offset += data.length;
                _this2.params.max_mtime = data[data.length - 1].mtime;
              }
              data = data.map(function (file) {
                return Object.assign(file, {
                  ftype: file.isshare ? 'sharefile' : 'file',
                  id: file && file.fileid
                });
              });
              return _context2.abrupt("return", data);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchDevice: function fetchDevice(source, config) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var baseUrl, params, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              baseUrl = "/api/v5/groups/tmp/devices/".concat(source.id, "/files");
              params = {
                offset: 0,
                count: 20
              };
              params = Object.assign({}, params, config.params);
              if (!config.loadMore) {
                _context3.next = 7;
                break;
              }
              params = Object.assign(params, _this3.params);
              if (!(_this3.params.offset === -1)) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", []);
            case 7:
              _context3.next = 9;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 9:
              _context3.t0 = _context3.sent;
              if (_context3.t0) {
                _context3.next = 12;
                break;
              }
              _context3.t0 = [];
            case 12:
              data = _context3.t0;
              data = data.files;
              if (data && data.length) {
                _this3.params.offset += data.length;
              }
              return _context3.abrupt("return", data);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchDevices: function fetchDevices(source, config) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var baseUrl, params, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              baseUrl = '/api/v5/groups/tmp/devices';
              params = {
                offset: 0,
                count: 100
              };
              params = Object.assign({}, params, config.params);
              if (!config.loadMore) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", []);
            case 5:
              _context4.next = 7;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 7:
              _context4.t0 = _context4.sent;
              if (_context4.t0) {
                _context4.next = 10;
                break;
              }
              _context4.t0 = [];
            case 10:
              data = _context4.t0;
              if (data.next_offset && data.next_filter) {
                _this4.params = Object.assign(_this4.params, {
                  offset: data.next_offset,
                  filter: data.next_filter
                });
              }
              data = data.devices;
              data = data.map(function (file) {
                file.ftype = file.type;
                return file;
              });
              return _context4.abrupt("return", data);
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchTags: function fetchTags(source, config) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var baseUrl, params, key, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              baseUrl = '/api/v3/tags/1/items';
              params = {
                offset: 0,
                count: 20,
                with_corp: true
              };
              key = 'item_list';
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this5.params);
              }
              _context5.next = 7;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 7:
              data = _context5.sent;
              if (data && data[key]) {
                data = data[key];
                _this5.params.offset += data.length;
              }
              data = data.map(function (item) {
                var groupid = item.groupid,
                  file = item.file,
                  group = item.group,
                  corpid = item.corpid,
                  origin = _objectWithoutProperties(item, _excluded);
                return Object.assign({}, file || group, {
                  // 实体文件/圈子的id
                  id: file && file.fileid,
                  corpid: corpid,
                  groupid: file && file.groupid || group && group.groupid || groupid || origin.id,
                  linkgroupid: file && file.linkgroupid,
                  name: file && file.fname || group && group.name || origin.desc
                });
              });
              return _context5.abrupt("return", data);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchSharingReceived: function fetchSharingReceived(source, config) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var baseUrl, key, params, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              baseUrl = '/api/v5/links';
              key = 'share';
              params = {
                offset: 0,
                count: 20
              };
              params = Object.assign({}, params, config.params);
              if (!config.loadMore) {
                _context6.next = 8;
                break;
              }
              params = Object.assign(params, _this6.params);
              if (!(_this6.params.offset === -1)) {
                _context6.next = 8;
                break;
              }
              return _context6.abrupt("return", []);
            case 8:
              _context6.next = 10;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 10:
              data = _context6.sent;
              if (data.next_offset && data.next_filter) {
                _this6.params = Object.assign(_this6.params, {
                  offset: data.next_offset,
                  filter: data.next_filter
                });
              }
              if (data && data[key]) {
                data = data[key];
              }
              data = data.map(function (item) {
                var file = item.file,
                  group = item.group;
                var obj = {
                  name: item.share_name,
                  fname: item.share_name,
                  ctime: item.share_ctime,
                  creator: item.share_creator
                };
                if (item.share_type === 'group') {
                  obj.groupid = group.groupid;
                  obj.mtime = group.mtime;
                  obj.type = 'normal';
                  obj.user_role = group.user_role;
                  obj.ftype = 'linkfolder';
                }
                return Object.assign({}, file || group, obj);
              });
              return _context6.abrupt("return", data);
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchAll: function fetchAll(source, config) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var baseUrl, params, key, data, secret;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              baseUrl = '/api/v5/groups/special/files';
              params = {
                offset: 0,
                count: 20,
                linkgroup: true
              };
              key = 'files';
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this7.params);
              }
              _context7.next = 7;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 7:
              _context7.t0 = _context7.sent;
              if (_context7.t0) {
                _context7.next = 10;
                break;
              }
              _context7.t0 = '';
            case 10:
              data = _context7.t0;
              if (data.next_offset && data.next_filter) {
                _this7.params = Object.assign(_this7.params, {
                  offset: data.next_offset,
                  filter: data.next_filter
                });
              }
              if (data && data[key]) {
                data = data[key];
              }
              data = data.map(function (file) {
                if (file.ftype === 'group' || file.ftype === 'linkfolder') {
                  return Object.assign(file, {
                    type: 'normal',
                    user_role: 'creator',
                    name: file.fname,
                    id: file.id,
                    linkgroupid: file.linkgroupid
                  });
                } else {
                  return file;
                }
              });
              if (_this7.hasSecretFolder && !config.hideSecretFolder && !config.loadMore) {
                secret = {
                  fname: '私密文件夹',
                  ftype: 'secretfolder'
                };
                if (_this7.isSecretExpired) {
                  secret.expired = true;
                }
                data.splice(0, 0, secret);
              }
              if (!config.loadMore && config.showDevices) {
                data.splice(0, 0, {
                  fname: t('combine.main.myDevice'),
                  ftype: 'devices'
                });
              }
              return _context7.abrupt("return", data);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchEnterprise: function fetchEnterprise(source, config) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var baseUrl, key, params, data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!source.groupid) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", _this8.fetchTeam(source, config));
            case 2:
              baseUrl = '/api/v5/groups';
              key = 'groups';
              params = {
                offset: 0,
                count: 20,
                companyid: source.corpid || source.id,
                with_special: true
              };
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this8.params);
              }
              _context8.next = 9;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 9:
              data = _context8.sent;
              if (data && data[key]) {
                data = data[key];
                _this8.params.offset += data.length;
              }
              data = data.map(function (group) {
                return Object.assign(group, {
                  id: 0,
                  groupid: group.id
                });
              });
              return _context8.abrupt("return", data);
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchTeam: function fetchTeam(source, config) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var routeName, id, linkgroupid, groupid, ftype, isTeam, baseUrl, params, key, data, corpTmp;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              routeName = source.routeName, id = source.id, linkgroupid = source.linkgroupid, groupid = source.groupid, ftype = source.ftype;
              if (routeName === 'Secret' && !groupid) {
                groupid = _this9.secretFolderID;
              }
              isTeam = ftype === 'linkfolder' || ftype === 'group';
              baseUrl = "/api/v5/groups/".concat(linkgroupid || groupid, "/files");
              params = {
                offset: 0,
                linkgroup: true,
                count: 20,
                parentid: isTeam ? 0 : id // group 不需要传
              };
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this9.params);
              }
              key = 'files';
              _context9.next = 10;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 10:
              data = _context9.sent;
              if (data.next_offset && data.next_filter) {
                _this9.params = Object.assign(_this9.params, {
                  offset: data.next_offset,
                  filter: data.next_filter
                });
              }
              if (data && data[key]) {
                data = data[key];
              }
              if (!config.loadMore && (isTeam || !id) && _this9.currentTeam.group_type === 'corpspecial') {
                try {
                  corpTmp = _this9.companyGroups.find(function (v) {
                    return v.type === 'corptmp';
                  });
                  if (corpTmp) {
                    data.splice(0, 0, {
                      corpid: corpTmp.company_id,
                      fname: corpTmp.name,
                      groupid: corpTmp.group_id,
                      group_type: corpTmp.type
                    });
                  }
                  // eslint-disable-next-line no-empty
                } catch (e) {}
              }
              return _context9.abrupt("return", data);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    fetchLinks: function fetchLinks(source, config) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var baseUrl, key, params, data;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              baseUrl = '/api/v5/links';
              key = 'share';
              params = {
                offset: 0,
                count: 20,
                append: false
              };
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this10.params);
              }
              _context10.next = 7;
              return fetchFilesByUrl(baseUrl, {
                params: params
              });
            case 7:
              data = _context10.sent;
              if (data.next_offset && data.next_filter) {
                _this10.params = Object.assign(_this10.params, {
                  offset: data.next_offset,
                  filter: data.next_filter
                });
              }
              if (data && data[key]) {
                data = data[key];
              }
              data = data.map(function (item) {
                var obj = {
                  name: item.share_name,
                  fname: item.share_name,
                  ctime: item.share_ctime,
                  creator: item.share_crshare_creatoreator
                };
                if (item.share_type === 'group') {
                  obj.groupid = item.group.groupid;
                  obj.mtime = item.group.mtime;
                  obj.type = 'normal';
                  obj.user_role = item.group.user_role;
                }
                return obj;
              });
              return _context10.abrupt("return", data);
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    fetchMyTeams: function fetchMyTeams(source, config) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var key, params, data;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!source.groupid) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", _this11.fetchTeam(source, config));
            case 2:
              key = 'teams';
              params = {
                offset: 0,
                count: 20
              };
              params = Object.assign({}, params, config.params);
              if (config.loadMore) {
                params = Object.assign(params, _this11.params);
              }
              _context11.next = 8;
              return fetchKdMyTeams({
                params: params
              });
            case 8:
              data = _context11.sent;
              if (data && data[key]) {
                _this11.params.offset = data.nextOffset;
                data = data[key];
              }
              data = data.map(function (group) {
                return Object.assign(group, {
                  corpid: 0,
                  id: 0,
                  groupid: group.id,
                  group_type: 'normal',
                  default_type: 'None',
                  secure: false,
                  type: 'normal'
                });
              });
              return _context11.abrupt("return", data);
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    }
  }
};

var MY_CLOUD = t('combine.main.myFile');
var MY_UPLOADED = t('combine.main.autoUpload');
var MY_DEVICE = t('combine.main.myDevice');
t('combine.main.latestOpen');
var WPSLATEST = t('combine.main.latest');
var RECEIVED = t('combine.main.receive');
var TRASH = t('combine.main.recBin');
t('combine.main.teamDocs');
t('combine.main.search');
var SECRET = t('combine.main.privateFile');
t('combine.main.team');
t('combine.main.appDriveTitle');
t('combine.main.appAccountTitle');
t('combine.main.appDriveTitleSimple');
t('combine.main.appDriveForgetTitle');
t('combine.main.starredFile');
var STARED = t('combine.main.stared');
t('combine.main.myFile');
var COOPERATION = t('combine.main.cooperation');
var SHARE$1 = t('combine.main.shareCom');
var MYTEAMS = t('combine.main.myTeams');
// 企业角色
({
  '1': t('combine.main.roles1'),
  '2': t('combine.main.roles2'),
  '3': t('combine.main.roles3')
});

var ROOT = {
  name: 'All',
  text: MY_CLOUD,
  key: 'MyCloud'
};
var SHARE = {
  name: 'Sharing',
  key: 'sharings',
  text: SHARE$1,
  params: {
    type: 'all'
  }
};
var STATIC_ROOT = {
  ALL: [ROOT],
  Mine: [ROOT],
  Teams: [ROOT],
  Stared: [],
  // yun的星标
  Tags: [{
    name: 'Tags',
    text: STARED,
    key: 'Tags'
  }],
  // 共享
  Sharing: [SHARE],
  Secret: [ROOT, {
    name: 'Secret',
    text: SECRET,
    key: 'secret'
  }],
  Lock: [ROOT, {
    name: 'Lock',
    text: SECRET,
    key: 'lock'
  }],
  Auto: [ROOT, {
    name: 'Auto',
    text: MY_UPLOADED,
    key: 'myUpload'
  }],
  Device: [ROOT, {
    name: 'Devices',
    text: MY_DEVICE,
    key: 'devices'
  }],
  Devices: [ROOT, {
    name: 'Devices',
    text: MY_DEVICE,
    key: 'devices'
  }],
  Latest: [{
    name: 'Latest',
    text: WPSLATEST,
    key: 'Latest'
  }],
  Received: [Object.assign({}, SHARE, {
    text: RECEIVED,
    params: {
      type: 'received'
    }
  })],
  Trash: [{
    key: 'trash',
    name: 'Trash',
    text: TRASH
  }],
  EntTrashRoot: [{
    key: 'trash',
    name: 'Trash',
    text: TRASH
  }],
  EntTrash: [{
    key: 'trash',
    name: 'Trash',
    text: TRASH
  }, {
    key: 'enttrash',
    name: 'EntTrash',
    text: ''
  }],
  Cooperation: [ROOT, {
    key: 'cooperation',
    name: 'Cooperation',
    text: COOPERATION
  }],
  MyTeams: [{
    key: 'myTeams',
    name: 'MyTeams',
    text: MYTEAMS
  }]
};

var pathMixin = {
  methods: {
    /**
     * 获取文件目录的完整路径
     */
    getFileFullPath: function getFileFullPath() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$source, id, groupid, corpid, routeName, name, fid, tid, cid, path, data, params, _data, filePath, corpSpecial, tmpIndex, specialItem, _filePath, _corpSpecial, _specialItem;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$source = _this.source, id = _this$source.id, groupid = _this$source.groupid, corpid = _this$source.corpid, routeName = _this$source.routeName;
              name = routeName;
              fid = id;
              tid = groupid;
              cid = corpid;
              path = [];
              if (!(name === 'Device' && id)) {
                _context.next = 14;
                break;
              }
              _context.next = 9;
              return fetchDevicesPath(id);
            case 9:
              data = _context.sent;
              params = {
                did: id
              };
              return _context.abrupt("return", [].concat(_toConsumableArray(path), [{
                key: "".concat(name, "_").concat(data.path.deviceid),
                name: name,
                text: data.path.dname,
                params: params
              }]));
            case 14:
              if (!fid) {
                _context.next = 30;
                break;
              }
              _context.prev = 15;
              _context.next = 18;
              return fetchFilePath(tid, fid);
            case 18:
              _data = _context.sent;
              filePath = _data && _data.path;
              filePath = _toConsumableArray(filePath);
              // 拼接 "我的企业文档"
              if (_this.currentTeam.group_type === 'corptmp') {
                corpSpecial = _this.companyGroups.find(function (v) {
                  return v.type === 'corpspecial';
                });
                if (corpSpecial) {
                  // 找到自动备份的index
                  tmpIndex = filePath.findIndex(function (v) {
                    return Number(v.groupid) === Number(_this.currentTeam.id);
                  });
                  specialItem = {
                    fname: corpSpecial.name,
                    corpid: corpSpecial.company_id,
                    groupid: corpSpecial.group_id
                  };
                  filePath.splice(tmpIndex, 0, specialItem);
                }
              }
              path = [].concat(_toConsumableArray(path), _toConsumableArray(filePath.map(function (p) {
                var params = {
                  fid: p.fileid,
                  cid: cid || p.corpid,
                  tid: p.groupid,
                  lid: p.linkgroupid
                };
                return {
                  key: "".concat(name, "_").concat(p.fileid ? p.fileid : p.groupid),
                  name: name,
                  text: p.fname,
                  params: params
                };
              })));
              _context.next = 28;
              break;
            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](15);
              console.log(_context.t0);
            case 28:
              _context.next = 38;
              break;
            case 30:
              if (!(name === 'Team')) {
                _context.next = 34;
                break;
              }
              return _context.abrupt("return", [{
                key: "Team_".concat(_this.currentTeam.id),
                name: 'Team',
                text: _this.currentTeam.name,
                params: {
                  tid: _this.currentTeam.id,
                  lid: _this.currentTeam.linkgroupid
                }
              }]);
            case 34:
              if (!(name === 'Enterprise' && tid)) {
                _context.next = 38;
                break;
              }
              // 拼接 "我的企业文档"
              _filePath = [];
              if (_this.currentTeam.group_type === 'corptmp') {
                _corpSpecial = _this.companyGroups.find(function (v) {
                  return v.type === 'corpspecial';
                });
                if (_corpSpecial) {
                  _specialItem = {
                    key: "Enterprise_".concat(_corpSpecial.group_id),
                    name: 'Enterprise',
                    text: _corpSpecial.name,
                    params: {
                      cid: cid,
                      tid: _corpSpecial.group_id
                    }
                  };
                  _filePath.unshift(_specialItem);
                }
              }
              return _context.abrupt("return", [].concat(_filePath, [{
                key: "Enterprise_".concat(_this.currentTeam.id),
                name: 'Enterprise',
                text: _this.currentTeam.name,
                params: {
                  cid: cid,
                  tid: _this.currentTeam.id
                }
              }]));
            case 38:
              return _context.abrupt("return", path);
            case 39:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[15, 25]]);
      }))();
    },
    /**
     * 获取根目录的路径
     */
    getRootPath: function getRootPath() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2$source, groupid, routeName, corpid, id, linkgroupid, name, fid, tid, cid, companyName, joinedCompanies, path, _yield$getKdMyTeamsDe, data, _ref, sources;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2$source = _this2.source, groupid = _this2$source.groupid, routeName = _this2$source.routeName, corpid = _this2$source.corpid, id = _this2$source.id, linkgroupid = _this2$source.linkgroupid;
              name = routeName;
              fid = id;
              tid = linkgroupid || groupid;
              cid = corpid || _this2.currentTeam.corpid;
              if (!(name === 'Enterprise')) {
                _context2.next = 15;
                break;
              }
              _context2.next = 8;
              return _this2.getJoinedCompanies();
            case 8:
              joinedCompanies = _context2.sent;
              path = [];
              joinedCompanies.filter(function (c) {
                if (c.corpid === cid) {
                  companyName = c.name;
                }
              });
              if (!tid || !fid) {
                path = [{
                  name: 'Enterprise',
                  text: companyName,
                  key: 'Enterprise',
                  params: {
                    cid: cid
                  }
                }];
              }
              return _context2.abrupt("return", path);
            case 15:
              if (!(name === 'Team')) {
                _context2.next = 30;
                break;
              }
              _context2.next = 18;
              return getKdMyTeamsDetail(groupid);
            case 18:
              _yield$getKdMyTeamsDe = _context2.sent;
              data = _yield$getKdMyTeamsDe.data;
              _ref = data || {}, sources = _ref.sources;
              if (!(sources && sources[0] === 'kdocs')) {
                _context2.next = 23;
                break;
              }
              return _context2.abrupt("return", STATIC_ROOT.MyTeams);
            case 23:
              if (!(_this2.currentTeam.user_role !== 'creator')) {
                _context2.next = 27;
                break;
              }
              return _context2.abrupt("return", STATIC_ROOT.Received);
            case 27:
              return _context2.abrupt("return", STATIC_ROOT[name] || STATIC_ROOT.ALL);
            case 28:
              _context2.next = 35;
              break;
            case 30:
              if (!(name === 'Sharing')) {
                _context2.next = 34;
                break;
              }
              return _context2.abrupt("return", STATIC_ROOT.Received);
            case 34:
              return _context2.abrupt("return", STATIC_ROOT[name] || STATIC_ROOT.ALL);
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * 获取当前的文件目录路径
     * {
     *   name: routeName
     *   test: 文案
     *   key: 定位用的key
     *   params: id等参数
     * }
     */
    getPath: function getPath() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var root, path;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getRootPath();
            case 2:
              root = _context3.sent;
              _context3.next = 5;
              return _this3.getFileFullPath();
            case 5:
              path = _context3.sent;
              return _context3.abrupt("return", [].concat(_toConsumableArray(root), _toConsumableArray(path)));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getJoinedCompanies: function getJoinedCompanies() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var allCompanies, user, _user$corp, name, id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetchJoinedCompanies();
            case 2:
              allCompanies = _context4.sent;
              user = _this4.user;
              if (!(allCompanies.length > 0)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", allCompanies.map(function (c) {
                return {
                  corpid: c.id,
                  name: c.name
                };
              }));
            case 8:
              if (!user.corp) {
                _context4.next = 11;
                break;
              }
              _user$corp = user.corp, name = _user$corp.name, id = _user$corp.id;
              return _context4.abrupt("return", [{
                name: name,
                corpid: id
              }]);
            case 11:
              return _context4.abrupt("return", []);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};

var ellised = false;
var pathChanged = false;
var fn;
var $els = {};
var breadcrumb = {
  name: 'kBreadcrub',
  components: {
    ElBreadcrumb: ElBreadcrumb,
    KIcon: KIcon,
    ElBreadcrumbItem: ElBreadcrumbItem
  },
  mixins: [Emitter],
  props: {
    path: Array
  },
  data: function data() {
    return {
      items: [],
      $els: {},
      boxAvg: false
    };
  },
  watch: {
    path: function path(v) {
      ellised = false;
      pathChanged = true;
      this.items = this.path;
      this.dispatch('KFinder', 'path', v);
    }
  },
  methods: {
    updateEl: function updateEl() {
      var _this = this;
      this.path.forEach(function (item) {
        try {
          $els[item.key] = Object.assign({}, item, {
            width: _this.$refs[item.key].$el.offsetWidth
          });
        } catch (e) {
          console.log(e);
        }
      });
    },
    ellis: function ellis() {
      if (ellised) {
        return;
      }
      ellised = true;
      var breadcrumbWidth = this.$refs.box && this.$refs.box.$el && this.$refs.box.$el.offsetWidth - 40 || 0;
      var itemsWidth = 0;
      var rendered = [];
      this.path.forEach(function (item) {
        var width = $els[item.key].width;
        itemsWidth += width;
        rendered.push(Object.assign({
          width: width
        }, item));
      });
      var beCuts = rendered.splice(1, rendered.length - 2);
      var WW = rendered.reduce(function (pre, cur) {
        return pre + cur.width;
      }, 0);
      var W = breadcrumbWidth - WW;
      if (itemsWidth >= breadcrumbWidth && beCuts.length > 0) {
        var detectWidth = 0;
        var leftIndex = 0;
        var rightIndex = beCuts.length - 1;
        var pointer = 'left';
        var _index = function _index() {
          var i = pointer === 'left' ? leftIndex : rightIndex;
          if (i < 0) {
            leftIndex = i = 0;
          }
          if (i >= beCuts.length) {
            rightIndex = i = beCuts.length - 1;
          }
          return i;
        };
        /* eslint-disable */
        while (true) {
          var index = _index();
          detectWidth += beCuts[index].width;
          if (detectWidth >= W) {
            if (pointer === 'left') {
              leftIndex--;
            } else {
              rightIndex++;
            }
            var _index2 = _index();
            detectWidth = detectWidth - beCuts[_index2].width;
            break;
          }
          if (pointer === 'left') {
            leftIndex++;
            pointer = 'right';
          } else {
            rightIndex--;
            pointer = 'left';
          }
        }
        var offset = [leftIndex, rightIndex - leftIndex + 1];
        var cutting = Array.from(beCuts);
        cutting.splice(offset[0], offset[1], Object.assign({}, cutting[offset[0] + offset[1] - 1], {
          text: '...',
          key: 'ellis',
          width: 50
        }));
        this.items = [rendered[0]].concat(cutting, [rendered[1]]);
      } else {
        this.items = this.path;
      }
    }
  },
  created: function created() {
    this.items = this.path;
  },
  render: function render(h) {
    var _this2 = this;
    var itemNum = this.items.length;
    var items = itemNum ? this.items : this.path;
    return h('el-breadcrumb', {
      ref: 'box',
      'class': {
        'file-breadcrub': true
      },
      props: {
        separator: ''
      }
    }, [items.map(function (item) {
      // 是否显示排序下拉框
      return h('el-breadcrumb-item', {
        'class': _defineProperty({}, 'multi-item', items.length > 1),
        ref: item.key,
        props: {
          key: item.key
        },
        nativeOn: {
          click: function click() {
            var params = item.params || {};
            var source = {
              routeName: item.name,
              groupid: params.tid,
              id: params.fid || params.did,
              corpid: params.cid,
              linkgroupid: params.lid,
              text: item.text,
              fname: item.text
            };
            _this2.dispatch('KFinder', 'source', source);
          }
        }
      }, item.text);
    }), h('k-icon', {
      props: {
        type: 'update'
      },
      'class': {
        'el-breadcrumb__item': true
      },
      nativeOn: {
        click: function click() {
          _this2.dispatch('DriveContainerRoot', 'handleFile', ['refresh', 'fromNav']);
        }
      }
    })]);
  },
  activated: function activated() {
    this.ellis();
  },
  mounted: function mounted() {
    var _this3 = this;
    var p = this;
    this.updateEl();
    setTimeout(function () {
      return _this3.ellis();
    }, 500);
    fn = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ellised = false;
              _context.next = 3;
              return p.$nextTick();
            case 3:
              p.ellis();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fn() {
        return _ref.apply(this, arguments);
      };
    }();
    window.addEventListener('resize', fn);
  },
  updated: function updated() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (pathChanged) {
              _this4.updateEl();
              pathChanged = false;
            }
            _context2.next = 3;
            return _this4.$nextTick();
          case 3:
            _this4.ellis();
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', fn);
  }
};

var FinderMain = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-finder-main",
      "class": {
        'with-rename': _vm.showRename
      },
      attrs: {
        "id": "kFinder"
      }
    }, [_c('div', {
      staticClass: "k-finder-main-header"
    }, [_c('div', {
      staticClass: "k-finder-main-header-navigator"
    }, [_c('control-button', {
      attrs: {
        "current": _vm.actionCurrent,
        "history": _vm.actionHistory
      },
      on: {
        "go": _vm.go
      }
    }), _vm._v(" "), _c('breadcrumb', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showBreadCrumb,
        expression: "showBreadCrumb"
      }],
      attrs: {
        "path": _vm.path
      }
    })], 1), _vm._v(" "), _c('KInputSearch', {
      staticClass: "k-finder-main-search-input",
      attrs: {
        "placeholder": _vm.isSelectFile ? _vm.lang_holder1 : _vm.lang_holder2,
        "onInput": _vm.onInput,
        "onClear": _vm.clearKeyword,
        "resetKeyword": _vm.resetKeyword,
        "clearText": _vm.lang_clear
      }
    })], 1), _vm._v(" "), !_vm.isPersonCloud || _vm.myCloud.id ? [_c('KFinderMainList', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.loading && _vm.items && _vm.items.length && !_vm.error,
        expression: "!loading && items && items.length && !error"
      }],
      attrs: {
        "isSelectFile": _vm.isSelectFile,
        "isMulti": _vm.isMulti,
        "isCrossGroup": _vm.isCrossGroup,
        "loadingMore": _vm.loadingMore,
        "secretLocked": _vm.secretLocked,
        "source": _vm.source,
        "selectedFile": _vm.selectedFile,
        "items": _vm.finderListItems,
        "actionType": _vm.actionType,
        "limitedExtArr": _vm.limitedExtArr,
        "isSecretExpired": _vm.isSecretExpired,
        "disableFileType": _vm.disableFileType,
        "limitedCompany": _vm.limitedCompany
      },
      on: {
        "loadmore": _vm.loadMore
      }
    }), _vm._v(" "), _vm.loading || _vm.error || _vm.items && !_vm.items.length ? _c('KFinderMainEmpty', {
      attrs: {
        "loading": _vm.loading,
        "source": _vm.source,
        "items": _vm.items,
        "error": _vm.error,
        "isSelectFile": _vm.isSelectFile
      }
    }) : _vm._e()] : _vm._e()], 2);
  },
  staticRenderFns: [],
  name: 'KFinderMain',
  componentName: 'KFinderMain',
  components: {
    KInputSearch: KInputSearch,
    KFinderMainEmpty: KFinderMainEmpty,
    KFinderMainList: KFinderMainList,
    breadcrumb: breadcrumb,
    ControlButton: ControlButton
  },
  mixins: [Emitter, pathMixin, fileMixin],
  props: {
    showRename: {
      type: Boolean
    },
    secretLocked: {
      type: Boolean
    },
    source: {
      type: Object
    },
    initSource: {
      type: Object
    },
    actionType: {
      type: String
    },
    hideSecretFolder: {
      type: Boolean
    },
    selectedFile: {
      type: Object
    },
    disableFileType: {
      type: Object
    },
    limitedCompany: {
      type: Object
    },
    user: {
      type: Object
    },
    myCloud: {
      type: Object
    },
    myUpload: {
      type: Object
    },
    currentTeam: {
      type: Object
    },
    isSelectFile: {
      type: Boolean
    },
    isMulti: {
      type: Boolean
    },
    isCrossGroup: {
      type: Boolean
    },
    showDevices: {
      type: Boolean
    },
    secretFolderID: {
      type: Number
    },
    limitedExtArr: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    limitedTabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      lang_holder1: t('combine.main.holder1'),
      lang_holder2: t('combine.main.holder2'),
      lang_clear: t('combine.main.clear'),
      actionCurrent: -1,
      // 用户当前位于历史记录数组的下标
      actionHistory: [],
      // 用户操作历史记录
      path: [],
      items: [],
      loading: false,
      prevSource: {},
      resetKeyword: false,
      loadingMore: false,
      error: '',
      companyGroups: [],
      context: {
        rootState: {
          file: {
            list: [],
            query: {
              pagination: {
                offset: 0,
                count: 100
              },
              sort: {
                order: 'DESC',
                sort_by: 'default'
              },
              ext: {
                include_file: true,
                search_group_info: true,
                include_first_letter: true,
                search_file_content: false,
                search_file_name: true
              }
            },
            selected: [],
            status: 'ENTERING',
            total: 0
          },
          user: {
            search_content_status: 2
          },
          route: {
            name: 'Search',
            params: {
              keyword: '',
              tabName: 'file'
            }
          }
        },
        commit: function commit() {},
        dispatch: function dispatch() {}
      }
    };
  },
  computed: {
    isPersonCloud: function isPersonCloud() {
      return this.$__SHIELD_CONFIG__ ? this.$__SHIELD_CONFIG__.featurePersonalCloud : true;
    },
    isSearch: function isSearch() {
      return this.source.routeName === 'Search';
    },
    showBreadCrumb: function showBreadCrumb() {
      if (this.error) {
        return false;
      }
      return ~['All', 'Enterprise', 'Team', 'Received', 'Secret', 'Sharing', 'Devices', 'Device', 'Latest', 'Tags', 'MyTeams'].indexOf(this.source.routeName);
    },
    finderListItems: function finderListItems() {
      if (this.$__SHIELD_CONFIG__ && !this.$__SHIELD_CONFIG__.UIFinderCorpspecial) {
        return this.items.filter(function (item) {
          return !(item && item.group_type && item.group_type === 'corpspecial');
        });
      } else {
        return this.items;
      }
    }
  },
  watch: {
    source: {
      handler: function handler(v) {
        this.onSourceChange(v);
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.$on('tryNewFolder', function () {
              _this.addFolder();
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onSourceChange: throttle( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(v) {
        var el, tid, teamInfo, currentCorpid, cid, res, src, i, oldV, isSameDir;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.error = '';
              this.resetKeyword = false;
              if (!this.isSearch) {
                _context2.next = 7;
                break;
              }
              this.dispatch('KFinder', 'error', '');
              return _context2.abrupt("return");
            case 7:
              this.resetKeyword = true;
            case 8:
              this.loading = true;
              try {
                el = document.querySelector('#kFinderList');
                el.scroll(0, 0);
              } catch (e) {
                /* eslint-disable */
              }
              this.dispatch('KFinder', 'error', '');
              this.dispatch('KFinder', 'selectFile', '');
              this.dispatch('KFinder', 'selectMultiFile', '');
              tid = v.linkgroupid || v.groupid;
              if (!tid) {
                _context2.next = 19;
                break;
              }
              _context2.next = 17;
              return fetchGroupFiles(tid);
            case 17:
              teamInfo = _context2.sent;
              this.dispatch('KFinder', 'setCurrentTeam', teamInfo);
            case 19:
              _context2.prev = 19;
              // 获取 企业自动备份和我的企业云文档 数据
              currentCorpid = v.corpid || this.currentTeam.corpid;
              cid = this.companyGroups.find(function (v) {
                return v.company_id;
              });
              if (!currentCorpid) {
                _context2.next = 33;
                break;
              }
              if (!(!cid || Number(cid) !== Number(currentCorpid))) {
                _context2.next = 33;
                break;
              }
              _context2.prev = 24;
              _context2.next = 27;
              return getCompanyPrivate(currentCorpid);
            case 27:
              res = _context2.sent;
              if (Array.isArray(res)) {
                this.companyGroups = res;
              }
              _context2.next = 33;
              break;
            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](24);
            case 33:
              _context2.t1 = Promise;
              _context2.next = 36;
              return this.fetch(v, {
                hideSecretFolder: this.hideSecretFolder,
                showDevices: this.showDevices
              });
            case 36:
              _context2.t2 = this.items = _context2.sent;
              _context2.next = 39;
              return this.getPath();
            case 39:
              _context2.t3 = this.path = _context2.sent;
              _context2.t4 = [_context2.t2, _context2.t3];
              _context2.next = 43;
              return _context2.t1.all.call(_context2.t1, _context2.t4);
            case 43:
              src = [];
              if (this.path && this.path.length > 1) {
                for (i = 0; i < this.path.length - 1; i++) {
                  src.push(this.path[i].text);
                }
              }
              this.dispatch('KFinder', 'src', src.join('/'));
              _context2.next = 53;
              break;
            case 48:
              _context2.prev = 48;
              _context2.t5 = _context2["catch"](19);
              console.log('KFinder handler err: ', _context2.t5);
              this.error = _context2.t5;
              this.dispatch('KFinder', 'error', _context2.t5);
            case 53:
              this.loading = false;

              // 如果不是来自历史记录的用户操作记录下来, 与当前是同一个文件夹不记录
              oldV = this.actionHistory[this.actionCurrent];
              isSameDir = v && oldV && v.groupid && v.groupid === oldV.groupid && v.id === oldV.id || v && oldV && !v.groupid && !oldV.groupid && v.routeName && v.routeName === oldV.routeName;
              if (v && !v.history && !isSameDir) {
                this.actionCurrent = this.actionCurrent + 1;
                this.actionHistory = this.actionHistory.slice(0, this.actionCurrent); // 在当前位置开始记录
                this.actionHistory.push(v);
              }
            case 57:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[19, 48], [24, 31]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 100),
    go: function go(flag) {
      // 前进
      var source;
      if (flag > 0) {
        if (this.actionCurrent + 1 < this.actionHistory.length) {
          this.actionCurrent = this.actionCurrent + 1;
          source = this.actionHistory[this.actionCurrent];
        }
      }
      // 后退
      else {
        if (this.actionCurrent > 0) {
          this.actionCurrent = this.actionCurrent - 1;
          source = this.actionHistory[this.actionCurrent];
        }
      }
      if (!source) {
        return;
      }
      source.history = true;
      this.dispatch('KFinder', 'source', source);
    },
    loadMore: function loadMore() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var moreData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.loadingMore = true;
              _context3.prev = 1;
              _context3.next = 4;
              return _this2.fetch(_this2.source, {
                hideSecretFolder: _this2.hideSecretFolder,
                loadMore: true
              });
            case 4:
              moreData = _context3.sent;
              if (moreData && moreData.length) {
                _this2.items = _this2.items.concat(moreData);
              }
              _context3.next = 12;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              _this2.error = _context3.t0;
              _this2.dispatch('KFinder', 'error', _context3.t0);
            case 12:
              _this2.loadingMore = false;
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      }))();
    },
    clearKeyword: function clearKeyword() {
      if (this.isSearch) {
        this.dispatch('KFinder', 'source', this.prevSource);
      }
    },
    onInput: function onInput(keyword) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var params, onlySearchAll, result, resp;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (keyword) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              if (!_this3.isSearch && !_this3.error || !keyword) {
                _this3.prevSource = Object.assign({}, _this3.source);
              }
              _this3.dispatch('KFinder', 'source', {
                routeName: 'Search',
                keyword: keyword
              });
              _this3.loading = true;
              _this3.context.rootState.route.params.keyword = keyword;
              params = Object.assign({}, _this3.context.rootState.file.query.pagination, _this3.context.rootState.file.query.sort, _this3.context.rootState.file.query.ext, {
                searchname: _this3.context.rootState.route.params.keyword,
                is_plus: _this3.user.is_plus
              });
              onlySearchAll = _this3.limitedTabs.length === 1 && _this3.limitedTabs[0] === 'All';
              if (onlySearchAll) {
                params.groupid = _this3.myCloud.id;
              }
              // 清空选择的节点
              _this3.items = [];
              _context4.next = 12;
              return searchFinderFile({
                params: params
              });
            case 12:
              result = _context4.sent;
              resp = [];
              if (!(!onlySearchAll && _this3.user.is_plus && _this3.user.corp && _this3.user.corp.id)) {
                _context4.next = 19;
                break;
              }
              params = {
                searchname: _this3.context.rootState.route.params.keyword,
                include: 'recent_members'
              };
              _context4.next = 18;
              return searchFinderGroup(_this3.user.corp.id, {
                params: params
              });
            case 18:
              resp = _context4.sent;
            case 19:
              if (_this3.context.rootState.route.params.keyword === keyword) {
                result = resp.concat(result);
                // 处理数据
                _this3.context.rootState.file.list = [];
                result.forEach(function (item) {
                  var id = item.id,
                    fname = item.fname,
                    ftype = item.ftype,
                    type = item.type;
                  var src = _this3.searchFilePath(item);
                  var rawData = Object.assign({}, item);
                  if (ftype === 'folder' || ftype === 'file' || ftype === 'sharefile' || ftype === 'linkfolder') {
                    _this3.context.rootState.file.list.push(Object.assign(rawData, {
                      name: fname,
                      src: src
                    }));
                  }
                  if (type === 'normal') {
                    delete rawData.id;
                    _this3.context.rootState.file.list.push(Object.assign(rawData, {
                      groupid: id,
                      src: src
                    }));
                  }
                });
                _this3.items = _this3.context.rootState.file.list;
              }
              _this3.loading = false;
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    searchFilePath: function searchFilePath(item) {
      var _private = t('combine.main.private');
      var _cloudFile = t('combine.main.cloudFile');
      var _langPrivate = new RegExp(_private);
      var _langFile = new RegExp(_cloudFile);
      var path = item.path,
        type = item.type,
        groupid = item.groupid,
        ftype = item.ftype,
        device_info = item.device_info,
        corpid = item.corpid;
      var myCloudId = this.myCloud.id;
      var myUploadid = this.myUpload.id;
      var cname = "".concat(item.company_name || t('combine.main.compFile'));
      path = item.new_path || path || '';
      var isReceivedPath = path.startsWith(t('combine.main.share')) || path.startsWith(t('combine.main.receive'));
      if (this.user.is_plus) {
        if (type === 'normal') {
          if (corpid) {
            path = cname;
          } else if (isReceivedPath) {
            path = t('combine.main.receive');
          } else if (ftype === 'linkfolder') {
            path = path.replace(_langPrivate, t('combine.main.myFile')) || path.replace(_langFile, t('combine.main.myFile')); // /^(私人空间)|(我的云文档)/, '我的文档'
          } else {
            path = t('combine.main.myFile');
          }
        } else if (path) {
          if (isReceivedPath) {
            path = "".concat(path.replace(t('combine.main.share'), t('combine.main.receive')));
          } else if (corpid) {
            path = "".concat(cname, "/").concat(path);
          } else if (![myCloudId, myUploadid].includes(groupid) && !(ftype === 'sharefile' && this.source.link)) {
            path = path.replace(_langPrivate, t('combine.main.myFile')) || path.replace(_langFile, t('combine.main.myFile')); // 正则表达式匹配变量错误
          }
        }
      }
      if (path === t('combine.main.autoUpload')) {
        path = t('combine.main.myDevice');
        // 取漫游信息显示设备名字
        if (item.device_info && device_info.id && device_info.name) {
          path = "".concat(t('combine.main.myFile'), "/").concat(t('combine.main.myDevice'), "/").concat(device_info.name);
        }
      }
      if (ftype === 'delfolder' || ftype === 'delfile' || ftype === 'delgroup') {
        path = t('combine.main.recBin');
      }
      path = path || t('combine.main.myFile');
      if (parseInt(groupid) === myCloudId) {
        return path.replace(_langPrivate, t('combine.main.myFile')) || path.replace(_langFile, t('combine.main.myFile'));
      }
      return path;
    },
    addFolder: function addFolder() {
      var _this4 = this;
      var index = 0;
      if (this.source.routeName === 'All') {
        if (this.items[0] && this.items[0].ftype === 'sharefolder') {
          index++;
        }
        if (this.items[1] && this.items[1].ftype === 'secretfolder') {
          index++;
        }
      }
      this.items.splice(index, 0, {
        name: t('combine.main.newFile') /*'新建文件夹'*/,
        ftype: 'folder',
        id: 0,
        "new": true,
        cb: function () {
          var _cb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this4.newFolder(name);
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function cb(_x2) {
            return _cb.apply(this, arguments);
          }
          return cb;
        }()
      });
      try {
        var el = document.querySelector('#kFinderList');
        el.scroll(0, 0);
      } catch (e) {}
    },
    deleteNewFolder: function deleteNewFolder() {
      this.items = this.items.filter(function (v) {
        return v && !v["new"];
      });
    },
    newFolder: function newFolder(name) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this5$source, groupid, id, _this5$source$routeNa, routeName, corpid, params, data, el, _ref2, msg;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (name) {
                _context6.next = 4;
                break;
              }
              _this5.deleteNewFolder();
              _context6.next = 28;
              break;
            case 4:
              _this5$source = _this5.source, groupid = _this5$source.groupid, id = _this5$source.id, _this5$source$routeNa = _this5$source.routeName, routeName = _this5$source$routeNa === void 0 ? '' : _this5$source$routeNa, corpid = _this5$source.corpid;
              if (~['All', 'Team', 'Enterprise', 'Secret'].indexOf(routeName)) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              if (routeName === 'All') {
                groupid = _this5.myCloud.id;
              }
              if (routeName === 'Secret') {
                groupid = _this5.secretFolderID;
              }
              _context6.prev = 9;
              params = {
                groupid: groupid,
                parentid: id || 0,
                name: name,
                parsed: true,
                owner: true
              };
              _context6.next = 13;
              return createFolder(params);
            case 13:
              _context6.t0 = _context6.sent;
              if (_context6.t0) {
                _context6.next = 16;
                break;
              }
              _context6.t0 = {};
            case 16:
              data = _context6.t0;
              data.name = data.fname;
              if (corpid) {
                data.corpid = corpid;
                data.routeName = 'Enterprise';
              } else {
                data.routeName = 'Team';
              }
              _this5.dispatch('KFinder', 'source', Object.assign(data));
              _context6.next = 28;
              break;
            case 22:
              _context6.prev = 22;
              _context6.t1 = _context6["catch"](9);
              el = document.querySelector('#kFinderNew');
              el.focus();
              _ref2 = _context6.t1.response && _context6.t1.response.data || {}, msg = _ref2.msg;
              Message.error(msg || t('combine.main.newFileErr') /*'创建文件夹失败'*/);
            case 28:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[9, 22]]);
      }))();
    }
  }
};

FinderMain.install = function (Vue) {
  Vue.component(FinderMain.name, FinderMain);
};

export { FinderMain as default };
